/* eslint-disable import/prefer-default-export */
/* eslint-disable no-useless-escape */
export const Common = {
  EVT_MODAL_CLICK: 20, // Click button in Modal
  EVT_MODAL_CREATE: 21, // Create Modal
  EVT_MODAL_MEDIA_CREATE: 22, // Create Modal (미리보기)
  EVT_MODAL_MOVIE_MAKE: 23, // Create Movie Make
  EVT_MENU_SELECT: 30, // Select Menu
  EVT_BREADCRUMB_DISPLAY: 31, // Breadcrumb 서브 메뉴
  EVT_TOAST: 32, // Toast
  EVT_IMG_SHOW: 40,
  EVT_PRELOAD_SHOW: 70, // Show preload
  EVT_PRELOAD_HIDE: 71, // Hide preload
  EVT_CB_MOVE_UP: 101, // Callback - 리스트 이동 (UP)
  EVT_CB_MOVE_DOWN: 102, // Callback - 리스트 이동 (DOWN),
  EVT_CB_SCREEN_TYPE: 103, // Callback - 영상 제작에서 화면 타입
  EVT_CB_MOV_MAKE_DATA: 104,

  CONST_LANG_KO: 'ko',
  CONST_LANG_JA: 'ja',
  CONST_LANG_EN: 'en',

  MOV_SLOT_TOTAL: 10,
  LIMIT_TAG: 5, // 생성할 수 있는 태그 총 수

  CODE_DEVICE_OK: '1C001',

  SORT_EMPTY: '',
  SORT_SHOP_NAME: 'shop_name',
  SORT_USER_NAME: 'user_name',
  SORT_TELNO: 'telno',
  SORT_USAGE: 'usage',
  SORT_FIRM: 'firm',
  SORT_REGION_NAME: 'region_name',
  SORT_RECENT_UPDATE: 'recent_update',
  SORT_SHOP_REGISTER_TIME: 'shop_register_datetime',

  EXP_TYPE_PHONE: /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/,
  EXP_TYPE_PW: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^*+=-]).{6,20}$/,
  EXP_TYPE_EMAIL:
    /[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/,
  EXP_TYPE_PHONE_INTERNATIONAL: /[^0-9 \- \– \— \) \( \+]+/,
  EXP_TYPE_SPECIAL_CHAR: /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi,
  EXP_TYPE_DATA_URI:
    /data:([\w\/\+]+);(charset=[\w-]+|base64).*,([a-zA-Z0-9+/]+={0,2})$/,
  EXP_TYPE_FILE_EXT: /\.([0-9a-z]+)(?:[\?#]|$)/i,

  EVT_CB_LIST_VIEW_COUNT: 0, // 리스트 뷰 개수
  EVT_CB_LIST_SEARCH_TEXT: 1, // 리스트 검색 텍스트
  EVT_CB_LIST_PAGE_PREV: 2, // 리스트 페이지 이동 (이전)
  EVT_CB_LIST_PAGE_NEXT: 3, // 리스트 페이지 이동 (다음)
  EVT_CB_LIST_PAGE: 4, // 리스트 페이지
  EVT_CB_LIST_APPROVAL_VIEW: 5, // 승인 대기 리스트 Show/Hide
  EVT_CB_MODAL_VAL: 6, // 팝업 값 전달
  EVT_CB_DEVICE_TYPE: 7, // 단말 타입 변경
  EVT_CB_MOV_ADD: 8, // 영상 추가
  EVT_COMPLETE: 9, // 이벤트 동작 완료
  EVT_STATUS_ACK: 10, // 지사 승인
  EVT_DEL_SHOP: 11, // 지사 삭제
  EVT_SELECT_CATEGORY: 12, // 카테고리 선택된 값 전달,
  EVT_MKVIDEO_IMG_DATA: 13,
  EVT_DEVICE_SETTING_DATA_RESET: 14, // 데이터 초기화

  MODAL_TYPE_BASE: 0, // 기본
  MODAL_TYPE_PREVIEW: 1, // 영상 미리보기
  MODAL_TYPE_ALL_THUMB: 2, // 전체 재생 목록 보기
  MODAL_TYPE_INFO: 3, // 전광판 정보 및 재생 목록
  MODAL_TYPE_GROUP: 4, // 그룹 불러오기
  MODAL_TYPE_GROUP_EDIT: 5, // 그룹 편집
  MODAL_TYPE_SIGNAGE: 6, // 전광판 불러오기
  MODAL_TYPE_TAG: 7, // 해쉬태그 추가&편집
  MODAL_TYPE_MOV_ADD: 8, // 영상 추가 (영상보관함)
  MODAL_TYPE_TIME: 9, // 시간 설정 (전체보내기)
  MODAL_TYPE_PW: 10, // 비밀번호 변경
  MODAL_TYPE_GROUP_LIST: 11, // 그룹 리스트
  MODAL_TYPE_CHANGE_NAME: 12, // 영상 이름 변경
  MODAL_TYPE_PW_FIND: 13, // 비밀번호 찾기
  MODAL_TYPE_USER: 14, // 사용자별로 보내기
  MODAL_TYPE_CATEGORY: 15, // 사용자별로 보내기

  SORT_ASC: 'asc',
  SORT_DESC: 'desc',

  LINK_DASHBOARD: '', // 대시보드
  LINK_LOGIN: 'login', // 로그인
  LINK_JOIN: 'join', // 일반 가입
  LINK_FRAN_JOIN: 'fran_join', // 프랜차이즈 가입
  LINK_PROFILE: 'profile', // 개인정보수정
  LINK_POLICY: 'policy', // 이용약관
  LINK_PRIVATE_POLICY: 'private', // 개인정보취급방침
  LINK_FRAN_USER: 'franchise/member', // 회원/태그 관린
  LINK_FRAN_GROUP: 'franchise/group', // 전광판 그룹 관리
  LINK_SIGN_VIEW: 'sign_list', // 전광판 정보 열람
  LINK_MANAGE_ALL: 'manage/all', // 전체 보내기
  LINK_MANAGE_GROUP: 'manage/group', // 그룹으로 보내기
  LINK_MOV_REG: 'movie/register', // 영상 등록
  LINK_MOV_LIST: 'movie/list', // 영상 보관
  LINK_MOV_MAKING: 'video', // 영상 제작하기
  LINK_SERVICE_SET: 'setting', // 서비스 설정
  LINK_SIGN_SET: 'device_setting', // 전광판 설정
  LINK_NOTICE_SERVER: 'notice/server', // 서버관리자 공지보기
  LINK_NOTICE_FRANCHISE: 'notice/franchise', // 프랜차이즈 공지하기
  LINK_MOV_STEP_ONE1: '/making/theme', // 테마(배경) 선택하여 제작
  LINK_MOV_STEP_ONE2: '/pages/video_upload', // 업로드하여 제작
  LINK_MOV_SETTING_EFFECT: '/pages/video_effect', // 문구 효과 설정
  LINK_MOV_ENCODING: '/pages/video_encoding', // 인코딩

  REQUEST_CODE_ADD: '1A001', // 추가
  REQUEST_CODE_DEL: '1A002', // 삭제
  REQUEST_CODE_ENABLE: '1A003', // 활성화
  REQUEST_CODE_DISABLE: '1A004', // 비활성화

  SESSION_IS_LOGIN: 'ss_login', // 로그인 유무
  SESSION_EMAIL: 'ss_email', // 사용자 이메일
  SESSION_F_CODE: 'ss_f_code', // 프랜차이즈 코드
  SESSION_F_COLOR: 'ss_f_color', // 프랜차이즈 컬러
  SESSION_F_NAME: 'ss_f_name', // 프랜차이즈 이름
  SESSION_USERS: 'ss_users', // 이름

  STORAGE_LANG: 'st_lang',

  Horizon1x1: '23002',
  Horizon2x1: '23003',
  Horizon3x1: '23004',
  Horizon3x3: '23005',
  Vertical2x1: '23006',
  Vertical4x1: '23007',

  CODE_OK: 100,

  GeneralUser: '12001', // 일반 사용자 (권한 코드)
  FranchiseBranchOffice: '12002', // 프랜차이즈 지사 사용자 (권한 코드)
  FranchiseHeadOffice: '12003', // 프랜차이즈 본사 사용자 (권한 코드)
  MultiUser: '12006', // 멀티 유저 (디바이스 타입 내의 user_role_code)

  MEBIBYTE_100: 104_857_600,
  MEBIBYTE_600: 629_145_600,

  MINUTE_15: 900,
  MINUTE_60: 3_600,
};
